import React from "react";
import { Link } from "react-router-dom";
import { Hero, Section, Cards, CTA } from "../components/Page/Page.js";
import { projects } from "../data/content.js";

export default function ImpactScreen() {
  return (
    <>
      <Hero title="Our Impact" text="Every project is certified, measured and reported, from avoided tonnes of CO2 to benefits for the communities involved." />
      <Section title="Where we make a difference" alt>
        <Cards items={[
          ["Climate", "Verified reductions in CO2 and methane."],
          ["Communities", "Cleaner energy, healthier homes, lower costs."],
          ["Transparency", "Public registry records for every credit."],
        ]} />
      </Section>
      <Section title="Our projects">
        <div className="pg-links">
          {projects.map((p) => <Link key={p.slug} to={`/projects/${p.slug}`}>{p.title} →</Link>)}
        </div>
      </Section>
      <CTA />
    </>
  );
}
